<template>
    <div id="print">
        <table id="barcodes">
            <tbody>
                <tr v-for="asset in assets">
                    <td>
                        <barcode
                            :value="asset.number"
                            :tag="'svg'"
                            :options="{
                                background: 'transparent',
                                displayValue: true,
                                format: 'CODE128',
                                width: 1,
                                height: 25
                            }"
                        >
                            {{ $t('ui.notifications.error.exception_error_please_contact_the_system_supplier') }}.
                        </barcode>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import VueBarcode from '@chenfengyuan/vue-barcode'
export default {
    name: "PrintAsset",
    props: {
    },
    data() {
        return {
            assets: [],
        }
    },
    watch: {

    },
    mounted() {
        this.init()
    },
    beforeDestroy() {
    },
    computed: {
    },
    methods: {
        async init() {
            await this.fetch_assets()
            await this.$nextTick(() => {
                $(".print").html($('#barcodes').clone())
            })
            await new Promise(resolve => {
                window.print()
                resolve()
            })
        },
        fetch_assets() {
            var url = this.$store.state.provider.routes.api_v1_provider_assets + "?category=" + this.$route.params.category
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    this.assets = response.data.assets
                })
                .catch(error => {
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.assets'),
                            reason: ': ' + error
                        })
                    )
                    return Promise.reject(error)
                })
        }
    },
    components: {
        'barcode': VueBarcode
    }
}
</script>

<style scoped>
    @media print {
        @page { margin: 0; }
        body { margin: 1.6cm; }
    }
</style>
